import commonMapping from "@/mapping/common";

export const staticRoutes = {
  private: commonMapping.intToBoolean,
  active: commonMapping.intToBoolean,
};

export default staticRoutes;
